/*
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-08-20 14:48:33
 * @LastEditors: guojia 66291979@qq.com
 * @LastEditTime: 2024-08-20 15:20:29
 * @FilePath: /lobby/src/common/mFbq.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
export const PIXEL_EVENT = {
  /** 查看内容_ViewContent*/
  VIEW_CONTENT: 'ViewContent',
  /** 完成注册_CompleteRegistration*/
  COMPLETE_REGISTRATION: 'CompleteRegistration',
  /** 登陆-SubmitApplication*/
  SUBMIT_APPlICATION: 'SubmitApplication',
  /** 开始试用游戏-StartTrial*/
  START_TRIAL: 'StartTrial',
  /** 加入购物车 -AddToCart*/
  ADD_TO_CART: 'AddToCart',
  /** 拉起订单-InitiateCheckout*/
  INITIATE_CHECKOUT: 'InitiateCheckout',
  /** 首充事件-Purchase*/
  PURCHASE: 'Purchase',
  /** 点击安装PWA-CustomizeProduct*/
  CUSTOMIZE_PRODUCT: 'CustomizeProduct'
}

export const mfbq = (eventName, eventData) => {
  fbq('trackCustom', eventName, eventData)
  return
}
